// Pre-Login Component - Main User Authentication
import React, { useState } from 'react';

const PreLoginComponent = ({ onPreLoginSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handlePreLogin = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            // Validate main user credentials
            const MAIN_USER = 'static2025';
            const MAIN_PASS = 'systemManagemenT()83762yg';

            if (username === MAIN_USER && password === MAIN_PASS) {
                // Store pre-login session
                localStorage.setItem('crm_prelogin', 'true');
                onPreLoginSuccess();
            } else {
                setError('Invalid system credentials');
            }
        } catch (error) {
            console.error('Pre-login error:', error);
            setError('Authentication failed');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url("https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        }}>
            <div style={{
                background: 'rgba(255, 255, 255, 0.95)',
                padding: '50px',
                border: '2px solid #1e293b',
                width: '100%',
                maxWidth: '450px',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
            }}>
                <div style={{
                    textAlign: 'center',
                    marginBottom: '40px',
                    borderBottom: '2px solid #1e293b',
                    paddingBottom: '20px'
                }}>
                    <h2 style={{
                        fontSize: '28px',
                        fontWeight: '700',
                        color: '#1e293b',
                        margin: '0 0 10px 0',
                        letterSpacing: '1px'
                    }}>SYSTEM ACCESS</h2>
                    <p style={{
                        margin: '0',
                        color: '#666666',
                        fontSize: '14px',
                        textTransform: 'uppercase',
                        letterSpacing: '2px'
                    }}>Main User Authentication</p>
                </div>

                <form onSubmit={handlePreLogin} style={{ marginBottom: '0' }}>
                    {error && (
                        <div style={{
                            background: '#1e293b',
                            color: '#ffffff',
                            padding: '12px',
                            marginBottom: '20px',
                            border: '1px solid #1e293b',
                            fontSize: '14px'
                        }}>
                            {error}
                        </div>
                    )}

                    <div style={{ marginBottom: '25px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#1e293b',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}>
                            System Username
                        </label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter system username"
                            required
                            disabled={isLoading}
                            autoComplete="off"
                            style={{
                                width: '100%',
                                padding: '12px',
                                border: '2px solid #1e293b',
                                fontSize: '14px',
                                background: '#ffffff',
                                color: '#1e293b',
                                boxSizing: 'border-box',
                                outline: 'none',
                                fontFamily: 'inherit'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#1e293b'}
                            onBlur={(e) => e.target.style.borderColor = '#1e293b'}
                        />
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#1e293b',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}>
                            System Password
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter system password"
                            required
                            disabled={isLoading}
                            autoComplete="off"
                            style={{
                                width: '100%',
                                padding: '12px',
                                border: '2px solid #1e293b',
                                fontSize: '14px',
                                background: '#ffffff',
                                color: '#1e293b',
                                boxSizing: 'border-box',
                                outline: 'none',
                                fontFamily: 'inherit'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#1e293b'}
                            onBlur={(e) => e.target.style.borderColor = '#1e293b'}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isLoading}
                        style={{
                            width: '100%',
                            padding: '14px',
                            background: '#1e293b',
                            color: '#ffffff',
                            border: '2px solid #1e293b',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            textTransform: 'uppercase',
                            letterSpacing: '2px',
                            transition: 'all 0.3s'
                        }}
                        onMouseOver={(e) => {
                            if (!isLoading) {
                                e.target.style.background = '#ffffff';
                                e.target.style.color = '#1e293b';
                            }
                        }}
                        onMouseOut={(e) => {
                            e.target.style.background = '#1e293b';
                            e.target.style.color = '#ffffff';
                        }}
                    >
                        {isLoading ? 'Authenticating...' : 'System Login'}
                    </button>
                </form>

                <div style={{
                    marginTop: '30px',
                    paddingTop: '20px',
                    borderTop: '1px solid #cccccc',
                    textAlign: 'center'
                }}>
                    <p style={{
                        margin: '0',
                        fontSize: '11px',
                        color: '#999999',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    }}>CRM System v2.0 - Secure Access</p>
                </div>
            </div>
        </div>
    );
};

export default PreLoginComponent;
